import HomePageMain from './modules/homePage/homepageMain';
new HomePageMain();
